import PersonIcon from '@mui/icons-material/Person'
import { Box, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { FC } from 'react'
import { EntityAvatar, EntityAvatarGroup, EntityAvatarGroupMember } from 'theme/components'
import { DensityStyleTypes } from 'types'

interface TeamDetailsProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  onEditClick?: (params: GridRenderCellParams) => void
}

const TeamMemberCell: FC<TeamDetailsProps> = ({ params, densityStyles, onEditClick }) => {
  const field = params?.field
  const team = Array.isArray(params?.row?._resolvedTeam?.[field]) ? params?.row?._resolvedTeam?.[field] : []
  const pinnedRow = params?.rowNode?.type === 'pinnedRow'
  // Don't render for aggregation rows (MUI auto-generated or server aggregation row)
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated || params?.row?.isAggregationRow) return null

  // Map team to EntityAvatarGroupMember format
  const members: EntityAvatarGroupMember[] = team.map((user: any) => ({
    id: user?.user_uuid || user?.id,
    userId: user?.user_uuid || user?.id,
    name: user?.name,
    photoUrl: user?.image_512,
    role: user?.role,
    tooltipContent: (
      <Box sx={{ p: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {user?.role ? (
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: renderColorByString(user?.role),
              }}
            >
              {user?.role}:
            </Typography>
          ) : null}
          <Typography variant="body2">{user?.name}</Typography>
        </Box>
      </Box>
    ),
  }))

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        height: '100%',
        flexWrap: 'wrap',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
      onClick={() => onEditClick(params)}
    >
      {members.length > 0 ? (
        <EntityAvatarGroup
          members={members}
          size={pinnedRow ? 'xs' : densityStyles.size}
          max={3}
          spacing={densityStyles.avatarSpacing}
          // enableNav
          showTooltips
        />
      ) : (
        <EntityAvatar
          size={pinnedRow ? 'xs' : densityStyles.size}
          fallbackIcon={
            <PersonIcon
              sx={{
                height: pinnedRow ? densityStyles?.avatarSizePinned : densityStyles?.iconSize,
                width: densityStyles?.iconSize,
              }}
            />
          }
          style={{ backgroundColor: 'background.defaultdim', opacity: 0.2 }}
        />
      )}
    </Box>
  )
}

export default TeamMemberCell
